









































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { RiskProfileStore, RoleStore, LoadingSpinnerService } from "@/store";
import {
  RiskProfileResultDto,
  ClientSelector,
  RiskProfileResultSectionDto,
  RangeGraphicType
} from "@/api/ClientPortalApiClient";
import BackButton from "@/components/BackButton.vue";
import router, { ROUTES } from "@/router";
import AlertService from "@/services/alert.service";
import VGauge from "vgauge";

@Component({
  name: "risk-profile-results",
  components: {
    VGauge,
    BackButton
  }
})
export default class RiskProfileResults extends Vue {
  private modalSubmitTitle: string = "modal-confirm-complete";

  riskProfileResults: RiskProfileResultDto = new RiskProfileResultDto();

  async created() {
    LoadingSpinnerService.Show("Loading risk profile results...");
    if (await RiskProfileStore.LoadResult()) {
      this.riskProfileResults = RiskProfileStore.Results;
    } else {
      const alert = new AlertService();
      alert.warn(
        "Risk Profile Results Not Available",
        "Please ensure you have successfully completed the risk profile questionnaire"
      );
      router.push({ name: ROUTES.home });
    }
    LoadingSpinnerService.Hide();
  }

  amend() {
    router.push({ name: ROUTES.riskprofiler });
  }

  submit() {
    this.$bvModal.show(this.modalSubmitTitle);
  }

  get riskProfileCompleted(): boolean {
    return RiskProfileStore.ProfileIsComplete;
  }

  get completedDate(): string {
    return RiskProfileStore.SelectedRequest.completedDate;
  }

  get contactName(): string {
    return RiskProfileStore.SelectedRequest.contactFullName || "";
  }

  get provider(): string {
    return RiskProfileStore.SelectedRequest.riskProfileType || "";
  }

  isRadial(section: RiskProfileResultSectionDto): boolean {
    return section.rangeGraphicType === RangeGraphicType.Radial;
  }

  isBarGraphic(section: RiskProfileResultSectionDto): boolean {
    return section.rangeGraphicType === RangeGraphicType.Bars;
  }

  get gaugeOptions(): any {
    return {
      staticZones: [
        { strokeStyle: "#28a745", min: 0, max: 24 }, // Conservative
        { strokeStyle: "#FFDD00", min: 25, max: 49 }, // Cautious
        { strokeStyle: "#f77808", min: 50, max: 74 }, // Balanced
        { strokeStyle: "#F03E3E", min: 75, max: 100 } // Growth
      ],
      angle: 0,
      lineWidth: 0.25,
      generateGradient: true,
      highDpiSupport: true,
      radiusScale: 1,
      limitMax: true,
      limitMin: true,
      pointer: {
        length: 0.5
      }
    };
  }

  GetBarSectionStyle(index: number, max: number, reverse: boolean) {
    index -= 1;
    const maxHue: number = 210;
    const interval: number = maxHue / (max - 1);
    const hue: number = reverse ? index * interval : maxHue - index * interval;
    return { "background-color": `hsl(${hue}, 70%, 45%)` };
  }

  async submitConfirmed() {
    LoadingSpinnerService.Show("Sending results to your adviser...");
    var result = await RiskProfileStore.CompleteRequest();
    if (result) {
      LoadingSpinnerService.Success("Risk Profile Completed Successfully!");
    } else {
      LoadingSpinnerService.Failure(
        "Unable to send your results. PLease try again."
      );
    }
    this.$bvModal.hide(this.modalSubmitTitle);
  }

  submitCancelled() {
    this.$bvModal.hide(this.modalSubmitTitle);
  }

  get backRoute(): string {
    return this.riskProfileCompleted ? ROUTES.home : ROUTES.riskprofiler;
  }

  get backText(): string {
    return this.riskProfileCompleted
      ? "Back to Dashboard"
      : "Back to Questionnaire";
  }
}
